import { defineStore } from 'pinia'

type MelTab = 'form' | 'excel'
type MelDataSource = 'form' | 'excel' | null
type MelOption = 'upload' | 'treatment' | 'shooting' | null
type Prestation = 'cintre' | 'efashion' | 'libredroit' | null

const STORAGE_KEY = 'efashion_mel_ui_state_v1'

export interface MelUiState {
  activeTab: MelTab
  melDataSource: MelDataSource
  selectedMelOption: MelOption
  selectedPrestation: Prestation
  savedAt?: number
}

const defaultState = (): MelUiState => ({
  activeTab: 'form',
  melDataSource: null,
  selectedMelOption: null,
  selectedPrestation: null,
  savedAt: Date.now()
})

function loadFromStorage(): MelUiState {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return defaultState()
    const parsed = JSON.parse(raw) as MelUiState
    if (!parsed || typeof parsed !== 'object') return defaultState()
    return { ...defaultState(), ...parsed }
  } catch (e) {
    return defaultState()
  }
}

function saveToStorage(state: MelUiState) {
  try {
    const data = { ...state, savedAt: Date.now() }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
  } catch (e) {
    // Erreur silencieuse lors de la sauvegarde
  }
}

export const useMelUiStore = defineStore('melUi', {
  state: () => loadFromStorage(),
  actions: {
    setActiveTab(tab: MelTab) {
      this.activeTab = tab
      saveToStorage(this.$state)
    },
    setMelDataSource(source: MelDataSource) {
      this.melDataSource = source
      saveToStorage(this.$state)
    },
    setSelectedMelOption(option: MelOption) {
      this.selectedMelOption = option
      saveToStorage(this.$state)
    },
    setSelectedPrestation(p: Prestation) {
      this.selectedPrestation = p
      saveToStorage(this.$state)
    },
    clear() {
      this.$state = defaultState()
      saveToStorage(this.$state)
    },
    persistNow() {
      saveToStorage(this.$state)
    }
  }
})
